import { render } from "./Discounts.vue?vue&type=template&id=6c501372&scoped=true"
import script from "./Discounts.vue?vue&type=script&lang=js"
export * from "./Discounts.vue?vue&type=script&lang=js"

import "./Discounts.vue?vue&type=style&index=0&id=6c501372&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c501372"]])

export default __exports__